import moment from "moment";
import { store } from '@common/store/store';
import { sDs } from '@common/sDs/sDs';
import { library } from "@common/library/library";
import { router } from "@common/router/router";
import { configStore } from "@common/configStore";
import { recordStore } from "@common/recordStore";
import { defineStore } from "pinia";

const uStoreObj = {
    state: () => ({
        loggedUsers: {},
        userData: {
            coordinator: {}
        },
        loggedUsersRequested: false,
        serverData: {},
        optionsData: {},
        dataAge: {},
        inactivityTimeout: 30, // minutes,
        inactivityMessage: false,
        inactivityLockMessage: false,
        inactivityLogoutFunction: function () { /* Why is this blank? */ },
        unlockErrorMessage: false,
        inited: false,
        pageIsLimited: false,
        activeUserRole: 'coordinator'
    }),
    getters: {
        activeUser: (state) => state.userData[state.activeUserRole],
        getAllUsers: (state) => state.userData,
        getCoordinatorUser: (state) => state.userData.coordinator,
        anyLoggedUser: (state) => Object.values(state.loggedUsers).find((val) => val !== 0)
    },
    actions: {
        async getUserData(type) {
            // Temporarily hard-code type
            type = 'coordinator';
            // Make sure we send at least one request to get logged users
            if (!this.loggedUsersRequested) {
                // 'user' in response from er_getLoggedUsers is 'coordinator' in userStore
                await this.getLoggedUsers([type, true]);
                this.loggedUsersRequested = true;
            }
            if (typeof IS_JEST === 'undefined' && !this.loggedUsers['user']) return this.userData[type]; // do not load info when user is not logged in
            if (typeof this.userData[type] === 'undefined') this.userData[type] = {};
            if (Object.keys(this.userData[type]).length !== 0) return this.userData[type];
            // Temporarily hard code sds requests
            let useSessionStorage = true;
            if (type === 'coordinator') {
                let promises = [
                    this.getData({ kName: 'ecUserField', fName: 'ec_userField', useSessionStorage }),
                    this.getData({ kName: 'ecUserProperty', fName: 'er_getEcUserProperty', useSessionStorage }),
                    this.getData({ kName: 'ecUserAvailableActivities', fName: 'ec_getGrid', params: [8, false, ["ACTIVITY_ENTITY_ID", "AE_TITLE"]] })
                ];
                await library.promiseAllSettled(promises);
                let activityObj = { availableActivities: this.serverData.ecUserAvailableActivities };
                this.userData[type] = library.mergeObj({}, this.serverData.ecUserProperty, this.serverData.ecUserField, activityObj);
                if (typeof navigationStore === 'function' && navigationStore().projectWithRouter) {
                    uStoreObj.sessions._sessionIntervalSeconds = 30;
                    uStoreObj.sessions.init();
                }
            } else if (type === 'vol') {
                let promises = [
                    this.getData({ kName: 'erVolFields', fName: 'er_volFields', useSessionStorage }),
                    this.getData({ kName: 'erVolLbes', fName: 'er_getLbeList', useSessionStorage })
                ];
                await library.promiseAllSettled(promises);
                this.userData[type] = library.mergeObj({}, this.serverData.erVolFields);
                this.userData[type].LOGBOOK_ENTRIES = this.serverData.erVolLbes;
                // TODO put this user's data into the recordStore
            }
            return this.userData[type];
        },
        async getData(payload) {
            let {
                kName,
                fName,
                params,
                useSessionStorage
            } = payload;
            if (this.serverData[kName]) return this.serverData[kName];
            if (useSessionStorage && library.getSessionStorage(kName)) {
                this.serverData[kName] = JSON.parse(library.getSessionStorage(kName));
                return this.serverData[kName];
            }
            this.serverData[kName] = false;
            let sDsParams = {
                sDsParams: {
                    cache: true
                }
            };
            if (!params) params = [];
            let response = await sDs.post(fName, ...params, sDsParams);
            if (response.status === 'success' && !library.objIsEmpty(response.data) && typeof (response.data) === 'object') {
                if (fName === 'ec_userField') {
                    let userKey = Object.keys(response.data)[0];
                    this.serverData[kName] = response.data[userKey];
                }
                else {
                    this.serverData[kName] = response.data;
                }
                if (useSessionStorage) {
                    library.setSessionStorage(kName, JSON.stringify(this.serverData[kName]));
                }
                if (response.fromServer) {
                    let ageKey = fName;
                    this.dataAge[ageKey] = moment().format("YYYY-MM-DD H:mm:ss");
                }
            }
            return this.serverData[kName];
        },
        async getLoggedUsers(payload) {
            if (typeof payload !== 'object') payload = {};
            let [psp, notSetInactivityTimeout, sendEmailIfNobodyIsLoggedIn] = Object.values(payload);
            if (psp === 'coordinator') psp = 'user';
            let loggedUsers = {};
            if (!this.pageIsLimited) {
                let response = await sDs.post('er_getLoggedUsers', false, true);
                if (response && response.status === 'success') {
                    loggedUsers = response.data;
                }
            } else {
                this.pageIsLimited = false;
            }
            this.loggedUsers = loggedUsers;
            // let anyLoggedUser = Object.values(this.loggedUsers).find((val) => val !== 0);
            if (sendEmailIfNobodyIsLoggedIn && !this.anyLoggedUser && typeof FROM_LOCALHOST !== 'undefined' && FROM_LOCALHOST) {
                sDs.post('sds_handleJsError', "\nLast 10 PHPSESSID: " + library.getLastLocalSessionIds(), '', 3, "VMS_9491 er_getLoggedUsers returns empty user after logging in");
            }
            if (this.anyLoggedUser && !this.inited) {
                this.inited = true;
                if (!notSetInactivityTimeout) {
                    let accountSettings = await configStore.getAccountSettings();
                    let inactivityTimeout = parseInt(accountSettings['ACCOUNT_INACTIVITY_LOGOUT_TIME'], 10) || 0;
                    if (inactivityTimeout) {
                        this.inactivityTimeout = inactivityTimeout;
                    }
                    if (typeof VUE_PROJECT_NAME !== 'undefined' && VUE_PROJECT_NAME === 'devDash') {
                        this.inactivityTimeout = parseInt(accountSettings['ACCOUNT_INACTIVITY_LOGOUT_TIME_499'], 10) || 0;
                    }
                    uStoreObj.inactivityLogout.init(
                        this.inactivityTimeout,
                        this.inactivityMessage,
                        this.inactivityLockMessage,
                        this.unlockErrorMessage,
                        () => {
                            this.inactivityLogoutFunction();
                        }
                    );
                    uStoreObj.sessions.init();
                }
            }
            if (psp) return this.loggedUsers[psp];
            return this.loggedUsers;
        },
        async logout(payload) {
            if (typeof payload !== 'object') payload = {};
            let [psp, withOutLogout] = Object.values(payload);
            this.inited = false;
            uStoreObj.sessions.stop();
            // clear out user information from local stores
            delete store.state.configStore.cfg.devDashLocalInstanceDetails;
            this.serverData = {};
            this.userData = {};
            if (!psp) psp = 'user';
            if (psp === 'user' && typeof navigationStore === 'function') navigationStore().clearStore();
            this.loggedUsers = {};
            if (typeof IS_JEST === 'undefined') {
                let tmpRecordStore = recordStore();
                if (tmpRecordStore && typeof tmpRecordStore.reset === 'function') tmpRecordStore.reset();
            }
            if (withOutLogout) {
                this.pageIsLimited = true;
            } else {
                await sDs.post('er_logOut', psp, true);
            }
            library.clearSessionStorage();
            library.hideAllDialogs();
            if (router) {
                let redirectTo;
                if (router.currentRoute && router.currentRoute.query && router.currentRoute.query.redirectTo) {
                    redirectTo = router.currentRoute.query.redirectTo;
                } else if (router.allRoutes && router.allRoutes.indexOf('/login') !== -1) {
                    redirectTo = '/login';
                }
                if (redirectTo && router.currentRoute && router.currentRoute._value && router.currentRoute._value.path && redirectTo !== router.currentRoute._value.path) {
                    router.replace({ path: redirectTo });
                }
            }
        },
    },
    inactivityLogout: {
        _inactivityTimeout: 10,
        _inactivityMessage: 'Your session has been inactive for %1! minutes. For security purposes, you will be logged out in %2! seconds. Click CONTINUE to remain logged in or click LOG OUT to end your session now.',
        _inactivityLockMessage: 'Your session has been locked',
        _inactivityTimerID: false,
        _inactivityLockTimerID: false,
        _inactivityLogoutFunction: async function () {
            await uStoreObj.actions.logout();
        },
        _inactivityCountdownTimer: false,
        _inactivityEnableBack: true,
        _inactivitySessionLockEnable: false,
        _unlockErrorMessage: false,
        _sessionLocked: false,
        _requireUserId: false,
        _initComplete: false,
        _sessionIsActive: false,
        _awayStartTime: false,
        init: function (inactivityTimeout, inactivityMessage, inactivityLockMessage, unlockErrorMessage, inactivityLogoutFunction, inactivitySessionLockEnable, requireUserId) {
            let t = this;
            if (inactivityTimeout && (parseInt(inactivityTimeout, 10) || 0) > 0) {
                t._inactivityTimeout = (parseInt(inactivityTimeout, 10) - 1) * 60 * 1000; // NOSONAR
            } else if ((parseInt(inactivityTimeout, 10) || 0) === 0) {
                return;
            }
            if (inactivityMessage) t._inactivityMessage = inactivityMessage;
            t._inactivityMessage = t._inactivityMessage.replace('%1!', parseInt(inactivityTimeout, 10) - 1);
            t._inactivityMessage = t._inactivityMessage.replace('%2!', '<span id="countdownTimer_placeholder">60</span>');
            if (inactivityLockMessage) {
                t._inactivityLockMessage = inactivityLockMessage;
                t._inactivityLockMessage = t._inactivityLockMessage.replace('%1!', parseInt(inactivityTimeout, 10));
            }
            if (inactivitySessionLockEnable) t._inactivitySessionLockEnable = inactivitySessionLockEnable;
            if (unlockErrorMessage) t._unlockErrorMessage = unlockErrorMessage;
            if (requireUserId) t._requireUserId = requireUserId;
            if (typeof inactivityLogoutFunction === 'function') {
                t._inactivityLogoutFunction = async function () {
                    t._sessionLocked = false;
                    t._sessionIsActive = false;
                    await uStoreObj.actions.logout();
                    inactivityLogoutFunction();
                };
            }
            t._inactivityTimerID = setTimeout(function () {
                t.show.call(t);
            }, t._inactivityTimeout);

            t._sessionIsActive = true;
            t._sessionLocked = false;
            if (!t._initComplete) {
                let oldBodyOnClick = document.body.onclick
                    ? document.body.onclick
                    : function () { /* empty to provide inaction */ };
                document.body.onclick = function () {
                    t.do_renew.call(t);
                    oldBodyOnClick();
                };
                document.addEventListener('mousemove', () => {
                    t.do_renew.call(t);
                });
                document.addEventListener("visibilitychange", function () {
                    if (document.hidden) {
                        let date = new Date();
                        t._awayStartTime = date.getTime();
                    } else if (t._awayStartTime) {
                        let date = new Date();
                        let awayTime = (date.getTime() - t._awayStartTime) / 1000; // NOSONAR
                        let maxAwayTimeSeconds = 1800;
                        if (maxAwayTimeSeconds < t._inactivityTimeout) {
                            maxAwayTimeSeconds = t._inactivityTimeout;
                        }
                        if (awayTime >= maxAwayTimeSeconds) {
                            t._inactivityLogoutFunction();
                        }
                    }
                });
                t._initComplete = true;
            }
        },
        show: function () {
            let t = this;
            if (t._sessionLocked) return;
            t._sessionLocked = true;
            window.focus();

            library.showDialog(t._inactivityMessage, () => {
                t._inactivityLogoutFunction();
            },
            () => { t._sessionLocked = false; }, { 'name': 'inactivityLogoutDiv', 'okButtonLabel': 'Log Out', 'cancelButtonLabel': 'Continue' });

            t._inactivityCountdownTimer = 60;
            if (t._inactivityTimerID) clearTimeout(t._inactivityTimerID);
            t._inactivityTimerID = setTimeout(function () {
                t._update.call(t);
            }, 1000); // NOSONAR
        },
        _update: function () {
            let t = this;
            if (!t._sessionLocked) return;
            let obj = document.getElementById('countdownTimer_placeholder');
            let btnObj = document.getElementById('inactivityLogout_continue');
            t._inactivityCountdownTimer--;

            if (t._inactivityCountdownTimer > 0) {
                window.focus();
                if (btnObj) btnObj.focus();
                if (obj) obj.innerHTML = t._inactivityCountdownTimer;
                if (t._inactivityTimerID) clearTimeout(t._inactivityTimerID);
                t._inactivityTimerID = setTimeout(function () { t._update.call(t); }, 1000); // NOSONAR
            } else {
                t.hide();
                t._sessionIsActive = false;
                t._sessionLocked = false;
                if (t._inactivitySessionLockEnable) {
                    // t.lock.call(t);
                    t._inactivityLogoutFunction();
                } else {
                    t._inactivityLogoutFunction();
                }
            }
        },
        hide: function () {
            library.hideDialog('inactivityLogoutDiv');
        },
        do_renew: function (needHide) {
            let t = this;
            if (!t._sessionIsActive) return;
            if (!t._sessionLocked) {
                this._sessionIsActive = true;
                if (t._inactivityTimerID) clearTimeout(t._inactivityTimerID);
                if (t._inactivityLockTimerID) clearTimeout(t._inactivityLockTimerID);
                t._inactivityTimerID = setTimeout(function () {
                    t.show.call(t);
                }, t._inactivityTimeout);
                if (needHide) {
                    t.hide();
                }
            }
        },
    },
    sessions: {
        _sessionIntervalSeconds: 120,
        _sessionTimerID: false,
        _sessionSID: false,
        init: async function () {
            let t = this;
            if (typeof navigationStore === 'function' && navigationStore().projectWithRouter) {
                // eslint-disable-next-line no-use-before-define
                if (typeof uStore === 'function' && uStore()?.userData?.coordinator?.SID) {
                    // eslint-disable-next-line no-use-before-define
                    t._sessionSID = uStore().userData.coordinator.SID;
                    if (t._sessionSID) {
                        t._sessionTimerID = setTimeout(function () { t._update.call(t); }, t._sessionIntervalSeconds * 1000); // NOSONAR
                    }
                }
            } else {
                let instance = await configStore.getDevDashLocalInstanceDetails({ refresh: true, addToSessionStorage: true });
                if (instance && instance.dis) {
                    t._sessionSID = instance.dis;
                    if (t._sessionSID) {
                        t._sessionTimerID = setTimeout(function () { t._update.call(t); }, t._sessionIntervalSeconds * 1000); // NOSONAR
                    }
                }
            }
        },
        _update: async function () {
            let t = this;
            if (!t._sessionSID) return;
            let response = await sDs.post("er_verifySessionId", t._sessionSID);
            if (!response.status || response.status !== 'success') {
                library.showToast((response.error ? response.error : 'Session expired'), { timeout: 10, type: 'error', name: 'sessionExpired' });
                uStoreObj.actions.logout();
            } else {
                if (response?.data?.needCheckAutomationEmails && typeof navigationStore === 'function') {
                    navigationStore()?.checkAutomations?.();
                }
                t._sessionTimerID = setTimeout(function () { t._update.call(t); }, t._sessionIntervalSeconds * 1000); // NOSONAR
            }
        },
        stop: function () {
            let t = this;
            t._sessionSID = false;
            if (t._sessionTimerID) clearTimeout(t._sessionTimerID);
        },
    },
    limitSession: {
        _inited: false,
        _projectName: 'devDash',
        _messageIsShown: false,
        init: async function () {
            if (typeof window.pageID === 'undefined') {
                window.pageID = library.getUniqueID();
            }
            let _this = this;
            if (typeof VUE_PROJECT_NAME !== 'undefined') {
                _this._projectName = VUE_PROJECT_NAME;
            }
            if (!_this._inited) {
                _this._inited = true;
                let onLocalStorageEvent = (e) => {
                    let mainPageID = _this.getMainPageID();
                    let isMainPage = window.pageID === mainPageID;
                    if (e.key === _this._projectName + "checkPages") {
                        // eslint-disable-next-line no-use-before-define
                        let anyLoggedUser = Object.values(uStore().loggedUsers).find((val) => val !== 0);
                        if (anyLoggedUser) {
                            _this.setMainPageID(window.pageID);
                            library.setLocalStorage(_this._projectName + 'pageOpenedAgain', Date.now());
                        }
                    }
                    if (e.key === _this._projectName + "openedPagesAdded") {
                        // eslint-disable-next-line no-use-before-define
                        let anyLoggedUser = Object.values(uStore().loggedUsers).find((val) => val !== 0);
                        if (anyLoggedUser) {
                            _this.setMainPageID(window.pageID);
                            library.setLocalStorage(_this._projectName + 'pageOpenedAgain', Date.now());
                        }
                    }
                    if (e.key === _this._projectName + "logoutOtherWindows" && !isMainPage) {
                        library.hideDialog('session-limit-by-tab', false, false, true);
                        uStoreObj.actions.logout(false, true);
                        _this.removePage(window.pageID);
                    }
                    if (e.key === _this._projectName + "alertMainWindow" && isMainPage) {
                        // disable alert feature for now
                        // eslint-disable-next-line no-alert
                        // alert("Active session is here");
                    }
                    if (e.key === _this._projectName + "pageOpenedAgain" && !isMainPage && !_this._messageIsShown) {
                        _this._messageIsShown = true;
                        library.showDialog('You already have an open ' + _this._projectName + ' project, would you like to continue working on this tab or go to an existing one?',
                            () => {
                                _this.setMainPageID(window.pageID);
                                _this._messageIsShown = false;
                                library.setLocalStorage(_this._projectName + 'logoutOtherWindows', Date.now());
                            },
                            () => {
                                uStoreObj.actions.logout(false, true);
                                _this._messageIsShown = false;
                                _this.removePage(window.pageID);
                                // disable alert feature for now
                                // localStorage[_this._projectName + 'alertMainWindow'] = Date.now();
                            },
                            {
                                name: 'session-limit-by-tab',
                                okButtonLabel: 'Continue on this tab',
                                cancelButtonLabel: 'Continue on existing tab'
                            });
                    }
                };
                window.addEventListener('storage', onLocalStorageEvent, false);
                _this.addPage(window.pageID);
                window.addEventListener('beforeunload', () => {
                    if (_this.isMainPage() && _this.openedPagesCount() > 1) {
                        // eslint-disable-next-line no-use-before-define
                        for (let psp in uStore().loggedUsers) {
                            if (psp === 'length') continue;
                            // eslint-disable-next-line no-use-before-define
                            if (uStore().loggedUsers[psp]) {
                                sDs.post('er_logOut', psp, true);
                            }
                        }
                    }
                    _this.removePage(window.pageID);
                });
                /* disable check active session on window focus for now
                window.addEventListener('focus', () => {
                    _this.checkPages();
                }); */
            }
        },
        addPage: function (pageID) {
            let pages = [];
            if (library.getLocalStorage(this._projectName + 'openedPages')) {
                pages = library.getLocalStorage(this._projectName + 'openedPages').split(',');
            }
            let openedPagesAdded = false;
            if (pages.indexOf(pageID) === -1) {
                pages.push(pageID);
                openedPagesAdded = true;
            }
            library.setLocalStorage(this._projectName + 'openedPages', pages);
            if (openedPagesAdded) {
                library.setLocalStorage(this._projectName + 'openedPagesAdded', Date.now());
            }
        },
        removePage: function (pageID) {
            let pages = [];
            if (library.getLocalStorage(this._projectName + 'openedPages')) {
                pages = library.getLocalStorage(this._projectName + 'openedPages').split(',');
            }
            let index = pages.indexOf(pageID);
            if (index > -1) {
                pages.splice(index, 1);
            }
            library.setLocalStorage(this._projectName + 'openedPages', pages);
        },
        openedPagesCount: function () {
            let pages = [];
            if (library.getLocalStorage(this._projectName + 'openedPages')) {
                pages = library.getLocalStorage(this._projectName + 'openedPages').split(',');
            }
            return pages.length;
        },
        isMainPage: function () {
            let mainPageID = false;
            if (library.getLocalStorage(this._projectName + 'mainPageID')) {
                mainPageID = library.getLocalStorage(this._projectName + 'mainPageID');
            }
            return mainPageID === window.pageID;
        },
        getMainPageID: function () {
            let mainPageID = false;
            if (library.getLocalStorage(this._projectName + 'mainPageID')) {
                mainPageID = library.getLocalStorage(this._projectName + 'mainPageID');
            }
            return mainPageID;
        },
        setMainPageID: function (pageID) {
            library.setLocalStorage(this._projectName + 'mainPageID', pageID);
        },
        checkPages: function () {
            this.setMainPageID(false);
            library.setLocalStorage(this._projectName + 'checkPages', Date.now());
        }
    }
};

const uStore = defineStore('userStore', uStoreObj);

// store.registerModule('userStore', userStore);
export { uStore, uStoreObj };
